// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const NodesGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#nodes-gradient_svga)"
      fillRule="evenodd"
      d="M14.94 7.96h-.5V6.11h1.86v1h-.86v.85zm6.91-1.85h-3.7v1h3.7v-1m1.85 0v1h3.7v-1zm5.56 0v1h3.7v-1zm5.55 0v1h.86v.85h1V6.11H34.8m1.86 3.7h-1v3.7h1zm0 5.56h-1v3.7h1zm0 5.56h-1v.85h-.86v1h1.86v-1.85m-3.7 1.85v-1h-.47v1zM15.43 9.8v1.86h.86v1h-3.7v-1h1.84V9.8h1m-6.05 3.7h-.5v-1.84h1.85v1h-.85v.85zm8.76-1.84v1h3.7v-1zm5.55 0v1h3.7v-1zm5.56 0v1h.85v.85h1v-1.85h-1.85m1.85 3.7h-1v3.7h1zm0 5.56h-1v3.7h1zm0 5.55h-1v.85h-.85v1h1.85v-1.85m-3.7 1.85v-1h-1.85v-10.1H9.89v-1.86h-1v1.85H3.33V33.9h22.23v-5.56z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="nodes-gradient_svga"
        x1={3.33}
        x2={31.59}
        y1={6.11}
        y2={38.34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "NodesGradient",
);
export default NodesGradientIcon;
